module.exports = __webpack_public_path__ + "img/health1_18-10-2021.210eb028.jpg";